import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {ApiClient} from './api.service';

export interface Comune {
  id: number;
  nome: string;
  provincia: string;
  /** "Arzignano (VI)" — composta qui, non arriva dall'API. */
  etichetta?: string;
}

/**
 * Elenco ISTAT dei comuni italiani, per le tendine "Comune".
 *
 * Sono 7.894 record (~395KB, ~83KB gzip): si scaricano una volta sola per
 * sessione e si cercano in locale, così la tendina risponde senza chiamate di
 * rete a ogni tasto premuto. `shareReplay` fa sì che le successive aperture
 * della modale riusino la stessa risposta.
 */
@Injectable({
  providedIn: 'root'
})
export class ComuniService {

  private cache: Observable<Comune[]> = null;

  constructor(private http: ApiClient) {
  }

  list(): Observable<Comune[]> {

    if (!this.cache) {
      this.cache = this.http.get('comuni').pipe(
        map((res: any) => res.data.map((comune: Comune) => ({
          ...comune,
          etichetta: `${comune.nome} (${comune.provincia})`
        }))),
        shareReplay(1)
      );
    }

    return this.cache;

  }

}
